import { FiltersTypes } from "@common/types/filters/general";
import { getDocumentFilters } from "@components/documents/FinancialDocumentsPageFilters/lib";
import { ActiveFilter, FilterTabs } from "@components/pageHeader/filters/lib";
import { getLockedActiveFilters } from "../shared/getLockedActiveFilters";

const ORG_LEVEL_FILTER_TABS: FilterTabs[] = [
    FilterTabs.UPLOAD_DATE,
    FilterTabs.DOCUMENT_STATUS,
    FilterTabs.DOCUMENT_TYPE,
    FilterTabs.DOCUMENT_PERIOD,
];

export const getFinancialDocumentsTaskFilterTabs = ({
    isWorkspaceScoped,
}: {
    isWorkspaceScoped: boolean;
}): FilterTabs[] =>
    isWorkspaceScoped ? getDocumentFilters() : ORG_LEVEL_FILTER_TABS;

const LOCKABLE_FILTER_TABS = new Set<FilterTabs>(getDocumentFilters());

export function getFinancialDocumentsLockedActiveFilters(
    originalFilters: FiltersTypes | undefined,
): ActiveFilter[] {
    return getLockedActiveFilters({
        lockableTabs: LOCKABLE_FILTER_TABS,
        originalFilters,
    });
}
